import React, { PureComponent } from 'react';

class ButtonEditar extends PureComponent {
    constructor(props) {
        super(props);
        this.onClickEditarAjuste = this.onClickEditarAjuste.bind(this);
    }

    onClickEditarAjuste(event) {
        this.props.editar(this.props.ajuste);
    }

    render() {
        return (<a className="clickable none-text-decoration ingresoAjustes-icono-edicion" aria-hidden="true" onClick={this.onClickEditarAjuste}></a>);
    }
}

export default ButtonEditar;